import { Container, Typography } from "@mui/material";
import { OurProjects } from "components/OurProjects";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import classes from "../../pages/About/about.module.scss";
import Empty from "components/Empty/Empty";
import { OurProjectsPagination } from "components/OurProjectsPagination";

const Competitions = () => {
  const { ourprojects } = useSelector((state) => state.ourprojects);
  const { t } = useTranslation();
  return (
    <Container>
      <Typography className={classes.main}>{t("projectsAboutUs")}</Typography>
      {ourprojects?.count ? <OurProjects /> : <Empty />}
      <OurProjectsPagination />
    </Container>
  );
};

export default Competitions;
